export default __webpack_public_path__ + "static/media/cart.51aef42a.svg";